import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import CircularProgress from '@mui/material/CircularProgress';
import { TimeoutType } from '../utils/utils';
import { useAppSelector } from '@/redux/hooks';

interface Props {
  disableSubmit?: boolean;
  disabledTip?: string;
  buttonText: string;
  buttonClass?: string;
  onSubmit: () => void;
}

export function SubmitBar(props: Props) {
  const {
    buttonText,
    disabledTip,
    disableSubmit,
    onSubmit,
  } = props;

  const [submitted, setSubmitted] = useState(false);
  const [submitTimeout, setSubmitTimeout] = useState<TimeoutType>();
  const networkRetry = useAppSelector(
    state => state.currentProblemState.networkRetry
  );

  useEffect(() => {
    return () => {
      if (submitTimeout) {
        clearTimeout(submitTimeout);
      }
    };
  }, [submitTimeout]);

  const compOnSubmit = (): void => {
    setSubmitted(true);

    onSubmit();

    setSubmitTimeout(
      setTimeout(() => {
        setSubmitted(false);
        setSubmitTimeout(undefined);
      }, 500)
    );
  };

  const isDisabled = disableSubmit || submitted || networkRetry;

  const onShow = () => {
    if (!disableSubmit || !disabledTip) {
      return false;
    }
  };
  return (
    <Tooltip onOpen={onShow} title={disabledTip}>
      <span style={{ marginTop: '1rem'}}>
        <Button
          fullWidth
          variant='contained'
          size='large'
          disabled={isDisabled}
          onClick={compOnSubmit}
        >
          {buttonText}
          {submitted && <CircularProgress color='success' size='20' />}
        </Button>
      </span>
    </Tooltip>
  );
}
